import saveReduxAction from 'modules/redux/actions/save'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import {
  TRAINING_USERS_ACTION,
  TRAINING_USERS_DOMAIN,
  TRAINING_USERS_ENDPOINT
} from 'modules/training/modules/training-users/constants'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import saveTrainingUserAction from 'modules/training/modules/training-users/actions/save/index.js'
import saveProfileAction from 'modules/profile/redux/actions/save/index.js'
import { getSelectedSubscriptionPlanSelect } from 'modules/training/modules/training-premium/selectors/get-selected-subscription-plan/index.js'
import { logEventSubscribeToPlanTrainingUserActionUtil } from 'modules/training/modules/training-users/actions/subscribe-to-plan/utils/logEvent/index.js'
import { getFreeTrialEndedAtUserSelect } from 'modules/training/modules/training-users/selectors/get-free-trial-ended-at/index.js'
import { closeHeaderBannerAction } from 'modules/headerBanner/actions/close/index.js'

/**
 * @param tokenId
 * @param subscriptionPlan
 * @returns {(function(*, *): Promise<void>)|*}
 */
export function subscribeToPlanTrainingUserAction ({
  tokenId,
  subscriptionPlan
}) {
  return async (dispatch, getState) => {
    const trainingUser = getCurrentTrainingUserSelect(getState())
    subscriptionPlan = (
      subscriptionPlan ||
      getSelectedSubscriptionPlanSelect(getState())
    )

    const freeTrialEndedAt = getFreeTrialEndedAtUserSelect(getState())
    const isTrial = !freeTrialEndedAt

    logEventSubscribeToPlanTrainingUserActionUtil({
      subscriptionPlan,
      isTrial
    })

    await Promise.all([
      dispatch(saveTrainingUserAction()),
      dispatch(saveProfileAction())
    ])

    await dispatch(
      saveReduxAction({
        type: TRAINING_USERS_ACTION.SUBSCRIBE_TO_PREMIUM,
        payload: {
          data: {
            subscriptionPlan,
            source: tokenId
          },
          domainPath: TRAINING_USERS_DOMAIN,
          endpoint: getEndpointTrainingUtil(TRAINING_USERS_ENDPOINT.SUBSCRIBE_TO_PLAN),
          path: getPathReduxUtil(trainingUser, TRAINING_USERS_DOMAIN)
        }
      })
    )

    dispatch(closeHeaderBannerAction())
  }
}
